// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --secondary-color: #194e54;
  --background-color: #fcf6f6;
  --default-text-color: #ffffff;
  --hover-background: #ffffff;
  --active-tab-color: #ffffff;
  --font-size: 17px;
  --font-weight: 600;
  --underline-color: #ffffff; 
}

.card-container {
  width: 94%;
  margin: 1.5rem auto;
  border-radius: 1.5625rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3),
    0 0.25rem 0.5rem rgba(0, 0, 0, 0.3), 0 0.5rem 1rem rgba(255, 249, 249, 0.2);
  overflow: hidden;
}

.custom-tabs-wrapper {
  width: 100%;
}

.custom-nested-tabs .ant-tabs-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative; 
  padding-bottom: 8px; 
}

.custom-nested-tabs .ant-tabs-tab {
  flex-grow: 1;
  text-align: center;
  padding: 0.5rem 0;
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  color: var(--default-text-color) !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-nested-tabs .ant-tabs-tab:hover {
  color: var(--hover-background) !important;
}

.custom-nested-tabs .ant-tabs-tab-active {
  color: var(--active-tab-color) !important;
}

.custom-nested-tabs .ant-tabs-ink-bar {
  background-color: var(--underline-color) !important;
  height: 3px; 
  border-radius: 2px; 
  bottom: 0; 
  position: absolute; 
  width: 100%; 
  transition: background-color 0.3s ease, transform 0.3s ease; 
}

.custom-tab-label {
  color: #ffffff;
  font-size: 1.26rem;
  font-weight: 600;
  padding: 0.5rem;
  text-align: center;
  width: 100%;
}

@media (max-width: 1024px) {
  .card-container {
    width: 95%;
  }

  .custom-nested-tabs .ant-tabs-nav {
    flex-wrap: wrap;
  }

  .custom-nested-tabs .ant-tabs-tab {
    min-width: 100px;
  }
}

@media (max-width: 768px) {
  .card-container {
    width: 100%;
    margin: 1rem 0;
  }

  .custom-nested-tabs .ant-tabs-nav {
    justify-content: space-around;
  }

  .custom-nested-tabs .ant-tabs-tab {
    flex: 1;
    padding: 0.5rem;
    min-width: 80px;
  }

  .custom-tab-label {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .custom-nested-tabs .ant-tabs-nav {
    flex-direction: column;
    align-items: stretch;
  }

  .custom-nested-tabs .ant-tabs-tab {
    width: 100%;
    padding: 0.5rem;
  }

  .custom-tab-label {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CardWithTabs/CardWithTabs.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB;+EAC6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mDAAmD;EACnD,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,OAAO;IACP,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --secondary-color: #194e54;\n  --background-color: #fcf6f6;\n  --default-text-color: #ffffff;\n  --hover-background: #ffffff;\n  --active-tab-color: #ffffff;\n  --font-size: 17px;\n  --font-weight: 600;\n  --underline-color: #ffffff; \n}\n\n.card-container {\n  width: 94%;\n  margin: 1.5rem auto;\n  border-radius: 1.5625rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3),\n    0 0.25rem 0.5rem rgba(0, 0, 0, 0.3), 0 0.5rem 1rem rgba(255, 249, 249, 0.2);\n  overflow: hidden;\n}\n\n.custom-tabs-wrapper {\n  width: 100%;\n}\n\n.custom-nested-tabs .ant-tabs-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative; \n  padding-bottom: 8px; \n}\n\n.custom-nested-tabs .ant-tabs-tab {\n  flex-grow: 1;\n  text-align: center;\n  padding: 0.5rem 0;\n  font-size: var(--font-size);\n  font-weight: var(--font-weight);\n  color: var(--default-text-color) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.custom-nested-tabs .ant-tabs-tab:hover {\n  color: var(--hover-background) !important;\n}\n\n.custom-nested-tabs .ant-tabs-tab-active {\n  color: var(--active-tab-color) !important;\n}\n\n.custom-nested-tabs .ant-tabs-ink-bar {\n  background-color: var(--underline-color) !important;\n  height: 3px; \n  border-radius: 2px; \n  bottom: 0; \n  position: absolute; \n  width: 100%; \n  transition: background-color 0.3s ease, transform 0.3s ease; \n}\n\n.custom-tab-label {\n  color: #ffffff;\n  font-size: 1.26rem;\n  font-weight: 600;\n  padding: 0.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .card-container {\n    width: 95%;\n  }\n\n  .custom-nested-tabs .ant-tabs-nav {\n    flex-wrap: wrap;\n  }\n\n  .custom-nested-tabs .ant-tabs-tab {\n    min-width: 100px;\n  }\n}\n\n@media (max-width: 768px) {\n  .card-container {\n    width: 100%;\n    margin: 1rem 0;\n  }\n\n  .custom-nested-tabs .ant-tabs-nav {\n    justify-content: space-around;\n  }\n\n  .custom-nested-tabs .ant-tabs-tab {\n    flex: 1;\n    padding: 0.5rem;\n    min-width: 80px;\n  }\n\n  .custom-tab-label {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .custom-nested-tabs .ant-tabs-nav {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .custom-nested-tabs .ant-tabs-tab {\n    width: 100%;\n    padding: 0.5rem;\n  }\n\n  .custom-tab-label {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
